import { EventDispatcher } from '@core/tools/EventDispatcher';
import { getContext, setContext } from 'svelte';
import type { Action } from 'svelte/action';

interface Options {}

export interface ViewController {
	onUpdate: EventDispatcher;
	inView: boolean;
}

export const createViewController = () => {
	const controller: ViewController = {
		onUpdate: new EventDispatcher(),
		inView: false
	};

	setContext('view', controller);
	return controller;
};

export const ViewController: Action<HTMLElement, Partial<Options> | undefined> = (
	node: HTMLElement,
	options
) => {
	// const rect = node.getBoundingClientRect();
	const controller = getContext('view') as ViewController;
	if (!controller) {
		throw new Error('EnterOnView must be used within a ViewController');
	}
	// controller.inView = rect.bottom < 0;
	// controller.onUpdate.trigger();

	function checkScrollOffset() {
		const rect = node.getBoundingClientRect();
		const before = controller.inView;
		controller.inView = rect.top - window.innerHeight < -window.innerHeight * 0.2;
		if (before !== controller.inView) {
			controller.onUpdate.trigger();
		}
	}
	window.addEventListener('scroll', checkScrollOffset);

	const observer = new IntersectionObserver(
		(entries) => {
			const entry = entries[0];
			if (entry.isIntersecting) {
				controller.inView = true;
				controller.onUpdate.trigger();
			} else {
				controller.inView = false;
				controller.onUpdate.trigger();
			}
		},
		{
			rootMargin: '5% 0px 5% 0px',
			threshold: 0.5
		}
	);

	requestAnimationFrame(checkScrollOffset);

	observer.observe(node);
	return {
		destroy() {
			observer.disconnect();
			window.removeEventListener('scroll', checkScrollOffset);
		}
	};
};
